import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from "../../../i18n";
import {
  withRouter,
  Form,
  Button,
  SidebarFormHeader,
  TextfieldElement,
  RadiosElement,
  CheckboxesElement,
  withProvidersApi,
  AutocompleteTextfieldApiElement
} from "cw-styleguide-react";

class ResultsFilterForm extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {

    return (
      <Form theme={['sidebar']} classes={['sidebar--can-collapse']}>
        <SidebarFormHeader
          heading={this.props.t('styleguide:forms.updateSearch')}
          searchButtonText={this.props.t('styleguide:forms.search')}
          handleSubmit={this.props.handleSubmit}
          handleReset={this.props.handleReset}
          availableFilters={this.props.t('view.results.messages.availableFilters')}
          filtersApplied={"1"}
        />

        <div className="form__body">



          {/*<TextfieldElement id={'courseTitle'} name={'courseTitle'}*/}
          {/*                  label={this.props.t('view.results.filters.courseTitle.label')}*/}
          {/*                  value={this.props.filterValues.courseTitle}*/}
          {/*                  onChange={this.props.handleChange}*/}
          {/*                  onClear={() => {this.props.handleClear('courseTitle')}}*/}
          {/*                  errors={this.props.formErrors['courseTitle']}*/}
          {/*/>*/}

          <TextfieldElement id={'keyword'} name={'keyword'}
            label={this.props.t('view.results.filters.keyword.label')}
            value={this.props.filterValues.keyword}
            onChange={this.props.handleChange}
            onClear={() => { this.props.handleClear('keyword') }}
            errors={this.props.formErrors['keyword']}
          />

          <TextfieldElement id={'location'} name={'location'}
            label={this.props.t('view.results.filters.location.label')}
            value={this.props.filterValues.location}
            onChange={this.props.handleChange}
            onClear={() => { this.props.handleClear('location') }}
            errors={this.props.formErrors['location']}
          />

          <RadiosElement
            id={'proximity'}
            name={'proximity'}
            label={this.props.t('view.results.filters.proximity.label.short')}
            options={this.props.filters.proximity}
            value={this.props.filterValues.proximity}
            defaultChecked={this.props.filterValues.proximity}
            onChange={this.props.handleChange}
            grouped={true}
          />

          <CheckboxesElement
            id={'qualificationType'}
            name={'qualificationType'}
            label={this.props.t('view.results.filters.qualificationType.label')}
            options={this.props.filters.qualificationType}
            value={this.props.filterValues.qualificationType}
            onChange={this.props.handleChange}
            grouped={true}
            scrollable={this.props.filters.qualificationType.length > 4}
          />

          <CheckboxesElement
            id={'studyMethodType'}
            name={'studyMethodType'}
            label={this.props.t('view.results.filters.studyMethodType.label')}
            options={this.props.filters.studyMethodType}
            value={this.props.filterValues.studyMethodType}
            onChange={this.props.handleChange}
            grouped={true}
            scrollable={this.props.filters.studyMethodType.length > 4}
          />

          <CheckboxesElement
            id={'studyMethodHours'}
            name={'studyMethodHours'}
            label={this.props.t('view.results.filters.studyMethodHours.label')}
            options={this.props.filters.studyMethodHours}
            value={this.props.filterValues.studyMethodHours}
            onChange={this.props.handleChange}
            grouped={true}
          />

          <CheckboxesElement
            id={'studyMethodTimes'}
            name={'studyMethodTimes'}
            label={this.props.t('view.results.filters.studyMethodTimes.label')}
            options={this.props.filters.studyMethodTimes}
            value={this.props.filterValues.studyMethodTimes}
            onChange={this.props.handleChange}
            grouped={true}
          />

          <CheckboxesElement
            id={'programme'}
            name={'programme'}
            label={this.props.t('view.results.filters.programme.label')}
            options={this.props.filters.programme}
            value={this.props.filterValues.programme}
            onChange={this.props.handleChange}
            grouped={true}
            scrollable={this.props.filters.programme.length > 4}
          />

          <CheckboxesElement
            id={'courseType'}
            name={'courseType'}
            label={this.props.t('view.results.filters.courseType.label')}
            options={this.props.filters.courseType}
            value={this.props.filterValues.courseType}
            onChange={this.props.handleChange}
            grouped={true}
          />

          <CheckboxesElement
            id={'courseGroupType'}
            name={'courseGroupType'}
            label={this.props.t('view.results.filters.courseGroupType.label')}
            options={this.props.filters.courseGroupType}
            value={this.props.filterValues.courseGroupType}
            onChange={this.props.handleChange}
            grouped={true}
            scrollable={this.props.filters.courseGroupType.length > 4}
          />

          <AutocompleteTextfieldApiElement api={this.props.providersApiGetEndpoint('providers_api_provider')}
            size={'large'}
            name={'mainProvider'}
            label={this.props.t('view.results.filters.provider.label')}
            description={this.props.t('view.results.filters.provider.description')}
            queryParameter={'name'}
            acceptLanguage={i18n.language}
            keyField={'atlasAccountId'}
            valueField={'providerName'}
            authorize={false}
            placeholder={this.props.t('view.results.filters.provider.placeholder')}
            value={this.props.filterValues.mainProviderId}
            keyword={this.props.filterValues.mainProviderLabel}

            onChange={this.props.handleChange} />


          <TextfieldElement id={'courseId'}
            name={'courseId'}
            label={this.props.t('view.results.filters.courseId.label')}
            value={this.props.filterValues.courseId}
            onChange={this.props.handleChange}
            onClear={() => { this.props.handleClear('courseId') }}
            errors={this.props.formErrors['courseId']}
          />


          <Button type={'submit'} icon={{ type: 'chevron-right', position: 'right' }} onClick={this.props.handleSubmit}>
            {this.props.t('styleguide:forms.search')}
          </Button>
          <input type={'reset'} value={this.props.t('styleguide:forms.clearFilters')} onClick={this.props.handleReset} />
        </div>
      </Form>

    );
  }
}

export default withProvidersApi(process.env)(withRouter(withTranslation('local')(ResultsFilterForm)));
